import { Flex, AvatarGroup, Avatar } from '@chakra-ui/react'
import { FaCheckCircle } from 'react-icons/fa'
import { iRespostaQuestao } from '../../../../../interfaces'
import { SkillAnswer } from '../../styles'

interface iProps {
  questao: iRespostaQuestao
}

export const QuestaoAlternativa: React.FC<iProps> = ({ questao }) => {
  return <>
    {questao.alternativaResposta?.map((r, i2) => {
      return (
        <Flex gap={'.75rem'} flexDir='row'>
          <AvatarGroup>
            {r.avatares?.map(avatar => {
              return <Avatar src={avatar} size={'xs'}/>
            })}
          </AvatarGroup>
          <SkillAnswer
            key={i2}
            type="button"
            isSelected={true}
            style={{ cursor: 'default' }}
          >
            <FaCheckCircle />
            <span>{r.resposta}</span>
          </SkillAnswer>
        </Flex>
      )
    })}
  </>
}
